
export default {
  name: "Input",
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    inputmode: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  methods: {
    // Keypress Validation Methods
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode);
      const letterRegex = /^[a-zA-Z-ğüşöçıİĞÜŞÖÇ\s]+$/;
      if (letterRegex.test(char)) return true;
      else e.preventDefault();
    },
    isNumber(e) {
      const char = String.fromCharCode(e.keyCode);
      const numberRegex = /^[0-9-+]+$/;
      if (numberRegex.test(char)) return true;
      else e.preventDefault();
    },
    emitInput(event) {
      this.$emit("input", event.target.value);

      // Keypress Validation
      switch (event.target.inputMode) {
        case "text":
          this.isLetter(event);
          break;
        case "numeric":
          this.isNumber(event);
          break;
        default:
          break;
      }
    },
  },
};
